module.exports = __webpack_public_path__ + "static/media/034.f1c356d9.jpg";